var ChartEvents = (function () {
    function ChartEvents(_a) {
        var pubsub = _a.pubsub;
        this.pubsub = pubsub;
    }
    ChartEvents.prototype.publish = function (_a) {
        var eventName = _a.eventName, meta = _a.meta;
        this.pubsub.publish(eventName, meta);
    };
    ChartEvents.prototype.subscribe = function (callback) {
        return this.pubsub.subscribe(function (eventName, meta) {
            if (meta === void 0) { meta = {}; }
            return callback({ eventName: eventName, meta: meta });
        });
    };
    return ChartEvents;
}());
export default ChartEvents;
